import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type ApprovalSlaStatus = 'pendente' | 'pendente_atencao' | 'expirado' | 'respondido';
export type ApprovalSlaStatusDetalhado = ApprovalSlaStatus | 'ignorado_reiterado';

export interface NetApprovalStatus {
  token_id: string;
  boletim_id: string;
  email_destinatario: string;
  created_at: string;
  expires_at: string;
  used_at: string | null;
  origem: string;
  enviado_por: string | null;
  quantidade_envios_por_boletim: number;
  envio_numero: number;
  horas_desde_envio: number;
  tempo_para_expirar: number;
  status: ApprovalSlaStatus;
  status_detalhado: ApprovalSlaStatusDetalhado;
  is_latest: boolean;
}

/** Fetch computed approval SLA status for a boletim */
export function useNetApprovalStatus(boletimId?: string) {
  return useQuery({
    queryKey: ['net-approval-status', boletimId],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('vw_net_approval_status')
        .select('*')
        .eq('boletim_id', boletimId!);
      if (error) throw error;
      return (data || []) as NetApprovalStatus[];
    },
    enabled: !!boletimId,
    staleTime: 30_000,
  });
}

/** Fetch latest approval status per contract (all boletins) */
export function useNetApprovalStatusByContract(contratoId?: string) {
  return useQuery({
    queryKey: ['net-approval-status-contract', contratoId],
    queryFn: async () => {
      // We need to join through boletim to get contract-level data
      // Since the view doesn't have contrato_id, we fetch all latest tokens
      // and filter client-side via the boletim relationship
      const { data, error } = await (supabase as any)
        .from('vw_net_approval_status')
        .select('*')
        .eq('is_latest', true);
      if (error) throw error;
      return (data || []) as NetApprovalStatus[];
    },
    enabled: !!contratoId,
    staleTime: 30_000,
  });
}
